import { createAction, props } from '@ngrx/store';
import { LocationRelationship } from 'src/app/admin/location/shared/models/locationRelationship';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';
import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';
import { TenantModel } from 'src/app/core/models/tenant';
import { UserSigninStatusModel } from 'src/app/lobby/shared/models/lobby-user-signin-status.model';
import { ACClientConfiguration } from 'src/app/shared/models/acClientConfiguration';
import { UserInfoDto } from './../../admin/user/shared/models/userinfo.dto';

export enum ActionTypes {
    LOAD_USER_INFO = '[Core] Load User Info',
    PROMPT_USER_SIGNIN = '[Core] Prompt User Signin',
    CLOSE_USER_SIGNIN_PROMPT = '[Core] Close User Signin Prompt',
    LOAD_SIGNIN_DETAILS_FOR_USER = '[Core] Load Signin User Details',
    LOAD_SIGNIN_DETAILS_FOR_USER_SUCCESS = '[Core] Load Signin User Details Succeess',
    SIGN_IN_USER = '[Core] SignInUser',
    UPDATE_USER_SIGNIN_STATUS = '[Core] Update User Signin Status',
    UPDATE_USERNAME = '[Core] Update User Name',
    SIGN_OUT_USER = '[Core] Sign OutUser',
    TIME_OUT_USER = '[Core] TimeOut User',
    UPDATE_USER_INFO = '[Core] Update User Info',
    UPDATE_TENANT = '[Core] Update Tenant',
    LOAD_AVAILABLE_TENANTS = '[Core] Load Available Tenants',
    UPDATE_AVAILABLE_TENANTS = '[Core] Update Available Tenants',
    LOAD_SELECTED_TENANT = '[Core] Load Selected Tenant',
    LOAD_System_Configurations = '[Core] Load System Configurations',
    LOAD_System_Configurations_API = '[Core] Load System Configurations Api',
    LOAD_System_Configurations_Success = '[Core] System Configurations Success',
    LOAD_System_Configurations_Api_Success = '[Core] System Configurations Api Success',
    LOAD_System_Configurations_Api_Failure = '[Core] System Configurations Api Failure',
    LOAD_URL_CODE = "LOAD_URL_CODE",
    UPDATE_URL_CODE = "UPDATE_URL_CODE",
    UPDATE_Location_Selector_Info = '[Core] Update Location Selector Info',
    UNABLE_TO_SIGN_IN_PROMPT = '[Core] Unable to Sign-in Prompt',
    CLOSE_UNABLE_TO_SIGN_IN_PROMPT = '[Core] Close Unable to Sign-in Prompt',
    LOAD_AVAILABLE_ACTIVE_BRANCHES = '[Core] Load Available Active Branches',
    UPDATE_Lobby_Location_Selector_Info = '[Core] Update Lobby Location Selector Info',
    UPDATE_AC_Location_Selector_Info = '[Core] Update AC Location Selector Info',
    LOAD_LOBBY_LOCATION_SELECTOR_STATUS = '[Core] Load Lobby Location Selector Status',
    LOAD_LOBBY_LOCATION_SELECTOR_STATUS_SUCCESS = '[Core] Load Lobby Location Selector Status Success',
    UPDATE_Lobby_Location_Selector_Status = '[Core] Update Lobby Location Selector Status',
    LOAD_AC_CLIENT_CONFIGURATION = '[Core] Load External Client Configuration',
    UPDATE_AC_CLIENT_CONFIGURATION = '[Core] Update External Client Configuration',
    LOAD_TENANT_LOGO_URL = '[Core] Load Tenant Logo Url',
    UPDATE_TENANT_LOGO_URL = '[Core] Update Tenant Logo Url',
    LOG_OUT_USER = '[Core] Log OutUser',
    UNABLE_TO_CHECK_IN_PROMPT = '[Core] Unable to Check-in Prompt',
    CLOSE_UNABLE_TO_CHECK_IN_PROMPT = '[Core] Close Unable to Check-in Prompt',
    SUBSCRIBE_SYNC_STATUS = '[Core] Subscribe Sync Status',
    SUBSCRIBE_SYNC_STATUS_SUCCESS = '[Core] Subscribe Sync Status Success',
    SUBSCRIBE_CLIENT_CREATE_STATUS = '[Core] Subscribe client create status',
    SUBSCRIBE_CLIENT_CREATE_STATUS_SUCCESS = '[Core] Subscribe client create status Success',
    UNSUBSCRIBE_SIGNALR_GROUP = '[Core] Unsubscribe From SignalR Groups',
    UNSUBSCRIBE_SIGNALR_GROUP_SUCCESS = '[Core] Unsubscribe From SignalR Groups Success',
    CLEAR_CLIENT_CREATE_STATUS = '[Core] Clear client create status',
    INITIALIZE_VIRTUAL_CONFERENCING_PROVIDER = '[Core] Initialize Virtual Conferencing Provider'
}

export const initializeVirtualConferencingProvider = createAction(
    ActionTypes.INITIALIZE_VIRTUAL_CONFERENCING_PROVIDER
);

export const loadAvailableActiveBranches = createAction(
    ActionTypes.LOAD_AVAILABLE_ACTIVE_BRANCHES,
    props<{ payload: { availableActiveBranches: LocationRelationship[] } }>()
);

export const promptUnableToSignin = createAction(
    ActionTypes.UNABLE_TO_SIGN_IN_PROMPT
);

export const loadSystemConfigurationSuccess = createAction(
    ActionTypes.LOAD_System_Configurations_Success
);
export const loadSystemConfigurationApiSuccess = createAction(
    ActionTypes.LOAD_System_Configurations_Api_Success,
    props<{ payload: { systemConfigurations: SystemConfigValue[] } }>()
);
export const loadSystemConfigurationApiFailure = createAction(
    ActionTypes.LOAD_System_Configurations_Api_Failure

);
export const closeUnableToSigninPopup = createAction(
    ActionTypes.CLOSE_UNABLE_TO_SIGN_IN_PROMPT
);

export const closeUnableToCheckinPopup = createAction(
    ActionTypes.CLOSE_UNABLE_TO_CHECK_IN_PROMPT
);

export const promptUnableToCheckin = createAction(
    ActionTypes.UNABLE_TO_CHECK_IN_PROMPT
);
export const unsubscribeFromSignalRGroups = createAction(
    ActionTypes.UNSUBSCRIBE_SIGNALR_GROUP,
    props<{ groupNames: string[] }>()
);

export const unsubscribeFromSignalRGroupsSuccess = createAction(
    ActionTypes.UNSUBSCRIBE_SIGNALR_GROUP_SUCCESS

);

export const promptUserToSignin = createAction(
    ActionTypes.PROMPT_USER_SIGNIN,
    props<{ payload: { isSelectorChange: boolean } }>()
);

export const loadUserInfo = createAction(
    ActionTypes.LOAD_USER_INFO
);

export const updateUserInfo = createAction(
    ActionTypes.UPDATE_USER_INFO,
    props<{ payload: { info: UserInfoDto } }>()
);

export const loadUrlCode = createAction(
    ActionTypes.LOAD_URL_CODE
);

export const updateUrlCode = createAction(
    ActionTypes.UPDATE_URL_CODE,
    props<{ payload: { urlCode: string } }>()
);

export const closeUserSigninPrompt = createAction(
    ActionTypes.CLOSE_USER_SIGNIN_PROMPT
);

export const userSignIn = createAction(
    ActionTypes.SIGN_IN_USER,
    props<{ payload: { userId: number, locationId: number, tenantId: number } }>()
);

export const userSignOut = createAction(
    ActionTypes.SIGN_OUT_USER,
    props<{ payload: { userId: number, locationId: number, reason: string, tenantId: number } }>()
);
export const userLogOut = createAction(
    ActionTypes.LOG_OUT_USER,
    props<{ payload: { userId: number, locationId: number, reason: string, tenantId: number } }>()
);

export const userTimeOut = createAction(
    ActionTypes.TIME_OUT_USER,
    props<{ payload: { userId: number, locationId: number, reason: string, tenantId: number } }>()
);

export const updateUserSigninStatus = createAction(
    ActionTypes.UPDATE_USER_SIGNIN_STATUS,
    props<{ payload: { status: UserSigninStatusModel, CurrentAssistingLobbyEntryId: number } }>()
);


export const loadSignInDetailsForUser = createAction(
    ActionTypes.LOAD_SIGNIN_DETAILS_FOR_USER,
    props<{ payload: { userId: number, tenantId: number, locationId: number } }>()
);

export const loadSignInDetailsSuccess = createAction(
    ActionTypes.LOAD_SIGNIN_DETAILS_FOR_USER_SUCCESS
);

export const updateSelectedTenant = createAction(
    ActionTypes.UPDATE_TENANT,
    props<{ payload: { tenant: TenantModel } }>()
);

export const loadAvailableTenants = createAction(
    ActionTypes.LOAD_AVAILABLE_TENANTS
);

export const updateAvailableTenants = createAction(
    ActionTypes.UPDATE_AVAILABLE_TENANTS,
    props<{ payload: { tenants: TenantModel[] } }>()
);

export const loadSystemConfigurations = createAction(
    ActionTypes.LOAD_System_Configurations,
    props<{ payload: { locationId: number, tenantId: number, userId: number } }>()
);
export const loadSystemConfigurationsApi = createAction(
    ActionTypes.LOAD_System_Configurations_API,
    props<{ payload: { locationId: number, tenantId: number, userId: number } }>()
);
export const loadSystemConfigurationsSuccess = createAction(
    ActionTypes.LOAD_System_Configurations_Success,
    props<{ payload: { systemConfigurations: SystemConfigValue[] } }>()
);

export const updateLocationSelectorInfo = createAction(
    ActionTypes.UPDATE_Location_Selector_Info,
    props<{ payload: { locationSelectorInfo: LocationSelectorInfo } }>()
);

export const updateLobbyLocationSelectorInfo = createAction(
    ActionTypes.UPDATE_Lobby_Location_Selector_Info,
    props<{ payload: { lobbyLocationSelectorInfo: LocationSelectorInfo } }>()
);

export const updateACLocationSelectorInfo = createAction(
    ActionTypes.UPDATE_AC_Location_Selector_Info,
    props<{ payload: { acLocationCode: string } }>()
);

export const loadLobbyLocationSelectorStatus = createAction(
    ActionTypes.LOAD_LOBBY_LOCATION_SELECTOR_STATUS,
    props<{ payload: { userId: number, locationId: number, tenantId: number } }>()
);

export const loadLobbyLocationSelectorStatusSuccess = createAction(
    ActionTypes.LOAD_SIGNIN_DETAILS_FOR_USER_SUCCESS

);

export const loadACClientConfiguration = createAction(
    ActionTypes.LOAD_AC_CLIENT_CONFIGURATION
);

export const updateACClientConfiguration = createAction(
    ActionTypes.UPDATE_AC_CLIENT_CONFIGURATION,
    props<{ payload: { acClientConfiguration: ACClientConfiguration } }>()
);

export const loadTenantLogo = createAction(
    ActionTypes.LOAD_TENANT_LOGO_URL
);

export const updateTenantLogo = createAction(
    ActionTypes.UPDATE_TENANT_LOGO_URL,
    props<{ payload: { tenantLogoUrl: string } }>()
);

export const subscribeToSyncStatus = createAction(
    ActionTypes.SUBSCRIBE_SYNC_STATUS,
    props<{ payload: { TenantId: number, UserId: number } }>()
);

export const subscribeToSyncStatusSuccess = createAction(
    ActionTypes.SUBSCRIBE_SYNC_STATUS_SUCCESS
);

export const subscribeToCreateClientStatus = createAction(
    ActionTypes.SUBSCRIBE_CLIENT_CREATE_STATUS,
    props<{ payload: { CreatedExternalUserId: string } }>()
);

export const subscribeToCreateClientSuccess = createAction(
    ActionTypes.SUBSCRIBE_CLIENT_CREATE_STATUS_SUCCESS
);

export const ClearCreateClientStatus = createAction(
    ActionTypes.CLEAR_CLIENT_CREATE_STATUS
);
